<template>
  <div class="flex flex-col gap-1 rounded p-2">
    <p class="text-center text-[10px] font-medium">{{ uppercaseTitle }}</p>
    <div v-if="isLoading" class="skeleton h-6 w-full rounded"></div>
    <p v-else class="text-center text-[22px]">{{ value }}</p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
  value?: number
  isLoading?: boolean
}>()

const uppercaseTitle = props.title.toUpperCase()
</script>
